import { ApiClientReturnType, KeyLabelType } from '~/types'
import api from '../http-common'

// DAIRY

const getClimaChOptions = (data?) =>
  api.post('/climate-check/footprints/get-index-data', data)

const getClimaChData = (data?) =>
  api.post('/climate-check/footprints/index', data)

const getClimaChCount = (data?) =>
  api.post('/climate-check/footprints/count', data)

const getClimaChActive = () =>
  api.post('/climate-check/footprints/count-active')

const getClimaChOptData = () =>
  api.post('/climate-check/footprints/get-options-data')

const getClimaChFarmGroupInfo = (data: FarmerGroupInfoType) =>
  api.post('/climate-check/footprints/get-options-data', data)

const getClimaCheck = (id: string) =>
  api.post(`/climate-check/footprints/${id}/edit`)

const createClimaCheck = (data?) =>
  api.post('/climate-check/footprints/store', data)

const updateClimaCheck = (id: string, data) =>
  api.post(`/climate-check/footprints/${id}/update`, data)

const planClimaCheck = (id: string) =>
  api.post(`/climate-check/footprints/${id}/plan`)

const deleteClimaCheck = (id: string) =>
  api.post(`/climate-check/footprints/${id}/delete`)

const getClimaChShowData = (id: string) =>
  api.post(`/climate-check/footprints/${id}/show`)

const getClimaChFarmerGroups = (id: string, data) =>
  api.post(`/climate-check/footprints/${id}/farmer-groups/index`, data)

const getClimaChFarmers = (id: string, data) =>
  api.post(`/climate-check/footprints/${id}/farmers/index`, data)

const getClimaChDairyResults = (id: string, farmerId: string) =>
  api.post(`/climate-check/footprints/${id}/farmers/${farmerId}/get-results`)

const getClimateCheckList = () =>
  api.post('climate-check/footprints/list')

const getClimaCheckSettings = () =>
  api.post('/settings/climate-check-footprint/edit')

const updateClimaCheckSettings = (data) =>
  api.post('/settings/climate-check-footprint/update', data)

// FARMER

const getClimaChAnswOptions = (id: string, data?): ApiClientReturnType<ClimaCheckOptionsType> =>
  api.post(`/climate-check/footprints/${id}/answer/get-options-data`, data)

const storeClimaChAnsw = (id: string, data) =>
  api.post(`/climate-check/footprints/${id}/answer/store`, data)

const getClimaChResults = (id: string, data) =>
  api.post(`/climate-check/footprints/${id}/answer/get-results`, data)

const getClimaChPredData = (id: string, data: any) =>
  api.post(`/climate-check/footprints/${id}/answer/cows/get-predefined-data`, data)

const getClimaChAnswers = (id: string, data) =>
  api.post(`/climate-check/footprints/${id}/answer/edit`, data)

const saveClimaChDraft = (id: string, data?) =>
  api.post(`/climate-check/footprints/${id}/answer/save`, data)

const checkClimaChStatus = (id: string, data?) =>
  api.post(`/climate-check/footprints/${id}/answer/check`, data)

const getHeifersClimaChPredData = (id: string, data: any) =>
  api.post(`/climate-check/footprints/${id}/answer/heifers/get-predefined-data`, data)

const getClimaChEnergyData = (id: string, type: ClimaCheckFeedType, data?) =>
  api.post(`/climate-check/footprints/${id}/answer/${type}/get-energy-data`, data)

const getClimaChEnergyAddition = (id: string, type: ClimaCheckFeedType, data?) =>
  api.post(`/climate-check/footprints/${id}/answer/${type}/calculate-energy-addition`, data)

const getCowsResults = (id: string, data?): ApiClientReturnType<CowResultsType> =>
  api.post(`/climate-check/footprints/${id}/answer/cows/get-results`, data)

const getHeifersResults = (id: string, data?): ApiClientReturnType<CattleResultsType> =>
  api.post(`/climate-check/footprints/${id}/answer/heifers/get-results`, data)

const getClimaChFarmerResults = (id: string) =>
  api.post(`/climate-check/footprints/${id}/get-results`)

const getClimaChPreviewFile = (id: string) =>
  api.post(`/climate-check/footprints/${id}/get-file`)

const disableFilePreview = (id: string, data) =>
  api.post(`/climate-check/footprints/${id}/answer/disable-file-preview`, data)

const getClimaChDlgFeed = (id: string, data) =>
  api.post(`/climate-check/footprints/${id}/answer/heifers/get-feeds`, data)

const getGrassSilagePredefinedData = (id: string, data) =>
  api.post(`/climate-check/footprints/${id}/answer/grass-silage/get-predefined-data`, data)

const getClimaChPreviousData = (id: string) =>
  api.post(`/climate-check/footprints/${id}/answer/get-previous-data`)

const ClimaCheckService = {
  getClimaChData,
  getClimaChOptions,
  getClimaChActive,
  getClimaChCount,
  getClimaChOptData,
  getClimaCheck,
  createClimaCheck,
  updateClimaCheck,
  planClimaCheck,
  deleteClimaCheck,
  getClimaChShowData,
  getClimaChFarmerGroups,
  getClimaChAnswOptions,
  storeClimaChAnsw,
  getClimaChResults,
  getClimaChPredData,
  getClimaChAnswers,
  saveClimaChDraft,
  checkClimaChStatus,
  getHeifersClimaChPredData,
  getClimaChFarmers,
  getClimaChEnergyData,
  getClimaChEnergyAddition,
  getCowsResults,
  getHeifersResults,
  getClimaChFarmGroupInfo,
  getClimaChFarmerResults,
  getClimaChDairyResults,
  getClimaChPreviewFile,
  disableFilePreview,
  getClimaChDlgFeed,
  getClimateCheckList,
  getClimaCheckSettings,
  updateClimaCheckSettings,
  getGrassSilagePredefinedData,
  getClimaChPreviousData
}

export default ClimaCheckService

export interface ClimaCheckOptionsType {
  breeds: ClimateCheckSelectType[];
  youngCattleBreeds: ClimateCheckSelectType[];
  organicFertilizers: OrganicFertilizerType[];
  growSilageTypes: KeyLabelType[];
  applyForageProductionInDataCollection: number;
  heiferRaisingMethods: HeiferRaisingMethod[];
  calfRearingTypes: {key: number, label: string}[];
  housingTypes: ClimateCheckSelectType[];
  manureStorageTypes: ClimateCheckSelectType[];
  energyConsumptions: EnergyConsumptions;
  cowsConcentratedFeeds: CowsConcentratedFeeds;
  youngCattleConcentratedFeeds: YoungCattleConcentratedFeeds;
  grassSilageOrganicFertilizerApplicationTechniques: {id: number, label: string} [];
  maizeSilageOrganicFertilizerApplicationTechniques: {id: number, label: string} [];
  irrigationMethods: KeyLabelType[];
  grainContentTypes: KeyLabelType[];
  juicyFeeds: JuicyFeed[];
  harvestingMethods: {id: number, label: string, hasMaturityLevelOptions: number} [];
  maturityLevels: {id: number, label: string, hasGrainContentOptions: number} [];
  mineralFertilizers: MineralFertilizerType[];
  plantProtections: {id: number, label: string} [];
  mineralFertilizerApplicationTechniques: {id: number, label: string} [];
  silageCoarseFeeds: SilageTypeFeed[];
  silageConcentratedFeeds: SilageTypeFeed[];
  limeTypes: KeyLabelType[];
  landTypes: ClimateCheckSelectType[];
  cowsCoarseFeeds: CoarseFeed[];
  manureFermentations: ClimateCheckSelectType[];
  youngCattleCoarseFeeds: CoarseFeed[];
  emissionReducingAdditives: EmissionReducingAdditive[];
  dairy: Dairy;
  climateCheckFootprint: ClimateCheckFootprint;
  cuttingFrequencies: KeyLabelType[];
  fertilizationTypes: KeyLabelType[];
  farmer: Farmer;
  filePreview: boolean;
  months: KeyLabelType[];
  locationFavorabilityTypes: KeyLabelType[];
  useMilkPrice: number;
  youngCattleValidationFeedGroups: YoungCattleValidationFeedGroup[];
  milkingTechnologies: KeyLabelType[];
  landscapeFeatureTypes: LandscapeFeatureType[];
  specialEcologicalAreas: SpecialEcologicalArea[];
  daysOffPerWeekOptions: KeyLabelType[];
  vacationPerYearOptions: KeyLabelType[];
  workloadOptions: KeyLabelType[];
  voluntaryEngagementOptions: KeyLabelType[];
  dryOffStrategyOptions: KeyLabelType[];
  mastitisAntibioticsUseOptions: KeyLabelType[];
  hoofCareFrequencyOptions: KeyLabelType[];
}

interface EnergyConsumptionChild {
  id: number;
  slug: string;
  category: number;
  order: string;
  parent_id: number | null;
  api_key: string | null;
  label: string;
  children?: EnergyConsumptionChild[];
}

export type EnergyConsumptions = EnergyConsumptionChild[];

export interface ClimateCheckSelectType {
  id: number;
  slug: string;
  label: string;
  api_key?: null | string;
}

export interface ClimateCheckFootprint {
  id: string;
  periodFrom: Date;
  periodTo: Date;
  start: string;
  end: string;
  withoutResults: number;
  statusLabel: string;
}

export interface CoarseFeed {
  id: number;
  internal_id: number;
  slug: string;
  name: string;
  status: number;
  type: number;
  api_key: null | string;
  api_key_dry_matter: null | string;
  api_key_energy: null | string;
  index: number | null;
  api_key_young_cattle_phase_one_percent: null | string;
  api_key_young_cattle_phase_two_percent: null | string;
  api_key_young_cattle_dry_matter: null | string;
  api_key_young_cattle_energy: null | string;
  young_cattle_index: number | null;
  order: number;
  label: string;
}

export interface CowsConcentratedFeeds {
  Energiekraftfutter: Eiweißkraftfutter[];
  Eiweißkraftfutter: Eiweißkraftfutter[];
  'Sonstige und Mineralfutter': Eiweißkraftfutter[];
}

export interface Eiweißkraftfutter {
  id: number;
  internal_id: number;
  slug: string;
  name: string;
  status: number;
  type: number;
  api_key: null | string;
  group: number | null;
  api_key_dry_matter: null | string;
  api_key_energy: null | string;
  index: number | null;
  api_key_young_cattle_phase_one_amount: null | string;
  api_key_young_cattle_phase_one_duration: null | string;
  api_key_young_cattle_phase_two_amount: null | string;
  api_key_young_cattle_phase_two_duration: null | string;
  api_key_young_cattle_dry_matter: null | string;
  api_key_young_cattle_energy: null | string;
  young_cattle_index: number | null;
  order: number;
  label: string;
  groupLabel: GroupLabel;
  info: string;
}

export enum GroupLabel {
  Eiweißkraftfutter = 'Eiweißkraftfutter',
  Empty = '',
  Energiekraftfutter = 'Energiekraftfutter',
  SonstigeUndMineralfutter = 'Sonstige und Mineralfutter',
}

export interface Dairy {
  companyName: string;
  languageId: number;
  additionalQuestionsOnClimateCheckModule: number;
}

export interface EmissionReducingAdditive {
  id: number;
  slug: string;
  status: number;
  hasTextAnswer: number;
  order: number;
  label: string;
}

export interface Farmer {
  id: string;
  companyName: string;
  supplierNo: string;
  totalMilkAmount: number;
  fat: null;
  protein: null;
  milkPrice: null;
  ureaContent: null;
  addressableId: string;
  streetName: string;
  streetNumber: string;
  zip: string;
  city: string;
  countryId: number;
  localDistrict: null;
  stateId: number;
  districtId: number;
  agricultureDistrictId: null;
  latitude: string;
  longitude: string;
  administrativeDistrictId: number;
  cantonId: number | null;
  iso: string;
  label: string;
  stateName: string;
  abbreviation: string;
  standardFat: string;
  standardProtein: string;
  fatPrice: string;
  proteinPrice: string;
  districtName: string;
  agricultureDistrict: null;
  amounts: any[];
  farmerId: string;
  dateFrom: Date;
  dateTo: null;
  saleTaxId: string;
  name: string;
  percent: string;
  status: number;
  saleTaxLabel: string;
}

export interface HeiferRaisingMethod {
  id: number;
  slug: string;
  order: number;
  label: string;
}

export interface JuicyFeed {
  id: number;
  slug: string;
  internal_id: number;
  api_key: string;
  api_key_dry_matter: string;
  api_key_energy: string;
  label: string;
}

export interface YoungCattleConcentratedFeeds {
  '': Eiweißkraftfutter[];
  Energiekraftfutter: Eiweißkraftfutter[];
  Eiweißkraftfutter: Eiweißkraftfutter[];
  'Sonstige und Mineralfutter': Eiweißkraftfutter[];
}

export type ClimaCheckFeedType = 'cows' | 'heifers'

interface FarmerGroupInfoType {
  periodFrom: string;
  periodTo: string;
  farmerGroupId: string;
}
export interface CattleResultsType {
  youngCattleGhgEmissionHeifersIdf: number
  youngCattleFemaleCalf: number
  youngCattleDigestion: number
  youngCattleFeedProductionAndLosses: number
  youngCattleManureAndBedding: number
  youngCattleWaterAndEnergy: number
  youngCattleDieselProductionAndCombustion: number
  youngCattleTotal: number
  youngCattleMachineManufacturing: number
  youngCattleGhgEmissionFromInputUseAndAnimalPurchase: number
  youngCattleGhgEmissionFromAnimalHusbandryPractices: number
  youngCattleGhgEmissionPerKgOfLivestockPerHeifer: number
  youngCattleGhgEmissionWithEconomicAllocationPerHeifer: number
  youngCattleGhgEmissionIdfPerHeifer: number
}
export interface CowResultsType {
  ghgEmissionMilkIdf: number
  ghgEmissionSlaughterCowsIdf: number
  ghgEmissionCalvesIdf: number
  soldMilk: number
  soldMilkFpcm: number
  soldMilkEconomicAllocationFpcm: number
  soldMilkEconomicAllocationFpcmIdf: number
  total: number
  inventoryAddition: number
  calfRearing: number
  digestion: number
  feedProductionAndLosses: number
  feeding: number
  manureAndBedding: number
  waterAndEnergy: number
  dieselProductionAndCombustion: number
  machineManufacturing: number
}

export interface OrganicFertilizerType {
  id: number;
  animalSpecies: string;
  type: string;
  slug: string;
  dryMatter: string;
  organicMatter: string;
  n: string;
  nh4N: string;
  nLosses: string;
  p2o5: string;
  k2o: string;
  order: number;
  animalSpeciesLabel: string;
  typeLabel: string;
  unit: string;
  label: string;
}

export interface MineralFertilizerType {
  id: number;
  slug: string;
  group: string;
  calculationGroup1: number;
  calculationGroup2: number;
  calculationGroup3: number;
  n: string;
  p2o5: string;
  k2o: string;
  order: number;
  label: string;
  groupLabel: string;
}

export interface SilageTypeFeed {
  id: number;
  internalId: number;
  slug: string;
  name: string;
  status: number;
  type: number;
  order: number;
  isSilageFeed: number;
  label: string;
}

export interface YoungCattleValidationFeedGroup {
  monthFrom: number;
  monthTo: number | null;
  warningMinValue: number;
  warningMaxValue: number;
  limitMinValue: number;
  limitMaxValue: number;
}

export interface LandscapeFeatureType {
  id: number;
  slug: string;
  unit: string;
  order: number;
  label: string;
  unitLabel: string;
  limitMaxValue: string | number;
  limitMinValue: string | number;
}

export interface SpecialEcologicalArea {
  id: number;
  slug: string;
  unit: string;
  order: number;
  label: string;
  unitLabel: string;
  limitMaxValue: string | number;
  limitMinValue: string | number;
}

